<template>
  <div>
    <v-col sm="8">
      <forms-customers-save :form-title="$t('Add {0}', [$t('Customer')])" />
    </v-col>
  </div>
</template>

<script>
import FormsCustomersSave from '@/components/forms/customers/FormsCustomersSave'

export default {
  components: {
    FormsCustomersSave
  }
}
</script>



// WEBPACK FOOTER //
// src/views/customers/Add.vue